window.AW_SEARCH_INTENT_MAP = [
  {
    "id": "P01",
    "type": "product",
    "title": "YS16-1 MAX 20Ah",
    "phrases": [
      "YS16-1 MAX 20Ah",
      "ys16 max 20ah",
      "ys16-1max 20 ah",
      "16-1 max 20ah"
    ],
    "target": "/products/anywell-ys16-max-wide-seat-electric-wheelchair-20ah",
    "preview": "YS16-1 MAX 20Ah\nPGPW00006-20AH"
  },
  {
    "id": "P02",
    "type": "product",
    "title": "YS16-1 MAX 12Ah",
    "phrases": [
      "YS16-1 MAX 12Ah",
      "ys16 max 12ah",
      "ys16-1max 12 ah",
      "16-1 max 12ah"
    ],
    "target": "/products/ys16-1-max-heavy-duty-wide-seat-power-wheelchair-12ah",
    "preview": "YS16-1 MAX 12Ah\nPGPW00006-12AH"
  },
  {
    "id": "P03",
    "type": "product_options",
    "title": "YS16-1 MAX",
    "phrases": [
      "YS16-1 MAX",
      "YS16 MAX",
      "YS16-1MAX",
      "16-1 MAX"
    ],
    "target": "/products/ys16-1-max-heavy-duty-wide-seat-power-wheelchair-12ah",
    "preview": "Compare the matching Anywell models for this search.",
    "options": [
      {
        "label": "YS16-1 MAX 12Ah",
        "href": "/products/ys16-1-max-heavy-duty-wide-seat-power-wheelchair-12ah"
      },
      {
        "label": "YS16-1 MAX 20Ah",
        "href": "/products/anywell-ys16-max-wide-seat-electric-wheelchair-20ah"
      }
    ]
  },
  {
    "id": "P04",
    "type": "product",
    "title": "YS12-15 PLUS",
    "phrases": [
      "YS12-15 PLUS",
      "YS12 15 PLUS",
      "YS1215 PLUS",
      "12-15 PLUS"
    ],
    "target": "/products/anywell-ys12-15-plus-folding-electric-wheelchair",
    "preview": "YS12-15 PLUS\nPGPW00004"
  },
  {
    "id": "P05",
    "type": "product",
    "title": "YA12-5",
    "phrases": [
      "YA12-5",
      "YA12 5",
      "YA125",
      "ya12—5"
    ],
    "target": "/products/anywell-ya12-5-long-range-durable-electric-wheelchair",
    "preview": "YA12-5 20Ah\nPGPW00002"
  },
  {
    "id": "P06",
    "type": "product",
    "title": "X-024",
    "phrases": [
      "X-024",
      "X024",
      "X 024",
      "x-24（建议变体，需人工确认）"
    ],
    "target": "/products/anywell-x-024-wide-seat-electric-mobility-scooter",
    "preview": "Contact official support for guidance on this topic for your exact model."
  },
  {
    "id": "P07",
    "type": "product",
    "title": "X-024 Orange",
    "phrases": [
      "X-024 Orange",
      "orange X024",
      "orange mobility scooter"
    ],
    "target": "/products/anywell-x-024-wide-seat-electric-mobility-scooter",
    "preview": "X-024 Orange\nPGPW00024-2"
  },
  {
    "id": "P08",
    "type": "product",
    "title": "X-024 Graphite Blue",
    "phrases": [
      "X-024 Graphite Blue",
      "blue X024",
      "graphite blue scooter"
    ],
    "target": "/products/anywell-x-024-wide-seat-electric-mobility-scooter",
    "preview": "X-024 Graphite Blue\nPGPW00024-1"
  },
  {
    "id": "P09",
    "type": "product",
    "title": "X-024 Red",
    "phrases": [
      "X-024 Red",
      "red X024",
      "red mobility scooter"
    ],
    "target": "/products/anywell-x-024-wide-seat-electric-mobility-scooter",
    "preview": "X-024 Red\nPGPW00024-3"
  },
  {
    "id": "P10",
    "type": "product",
    "title": "Electric wheelchair",
    "phrases": [
      "electric wheelchair",
      "power wheelchair",
      "power chair",
      "electric wheel chair"
    ],
    "target": "/collections/electric-wheelchairs",
    "preview": "Contact official support for guidance on this topic for your exact model."
  },
  {
    "id": "P11",
    "type": "product",
    "title": "Mobility scooter",
    "phrases": [
      "mobility scooter",
      "electric mobility scooter",
      "four wheel scooter",
      "4-wheel scooter"
    ],
    "target": "/collections/electric-mobility-scooters",
    "preview": "Contact official support for guidance on this topic for your exact model."
  },
  {
    "id": "P12",
    "type": "product_options",
    "title": "Wide-seat power wheelchair",
    "phrases": [
      "wide-seat power wheelchair",
      "wide seat wheelchair",
      "extra wide power chair"
    ],
    "target": "/products/ys16-1-max-heavy-duty-wide-seat-power-wheelchair-12ah",
    "preview": "Compare the matching Anywell models for this search.",
    "options": [
      {
        "label": "YS16-1 MAX 12Ah",
        "href": "/products/ys16-1-max-heavy-duty-wide-seat-power-wheelchair-12ah"
      },
      {
        "label": "YS16-1 MAX 20Ah",
        "href": "/products/anywell-ys16-max-wide-seat-electric-wheelchair-20ah"
      }
    ]
  },
  {
    "id": "P13",
    "type": "product_options",
    "title": "22.05 inch seat wheelchair",
    "phrases": [
      "22.05 inch seat wheelchair",
      "22.05 in seat",
      "22-inch wide-seat wheelchair（近似问法）"
    ],
    "target": "/products/ys16-1-max-heavy-duty-wide-seat-power-wheelchair-12ah",
    "preview": "Compare the matching Anywell models for this search.",
    "options": [
      {
        "label": "YS16-1 MAX 12Ah",
        "href": "/products/ys16-1-max-heavy-duty-wide-seat-power-wheelchair-12ah"
      },
      {
        "label": "YS16-1 MAX 20Ah",
        "href": "/products/anywell-ys16-max-wide-seat-electric-wheelchair-20ah"
      }
    ]
  },
  {
    "id": "P14",
    "type": "product_options",
    "title": "400 lb power wheelchair",
    "phrases": [
      "400 lb power wheelchair",
      "400 lbs capacity wheelchair",
      "heavy duty power wheelchair"
    ],
    "target": "/products/ys16-1-max-heavy-duty-wide-seat-power-wheelchair-12ah",
    "preview": "Compare the matching Anywell models for this search.",
    "options": [
      {
        "label": "YS16-1 MAX 12Ah",
        "href": "/products/ys16-1-max-heavy-duty-wide-seat-power-wheelchair-12ah"
      },
      {
        "label": "YS16-1 MAX 20Ah",
        "href": "/products/anywell-ys16-max-wide-seat-electric-wheelchair-20ah"
      }
    ]
  },
  {
    "id": "P15",
    "type": "product",
    "title": "400 lb mobility scooter",
    "phrases": [
      "400 lb mobility scooter",
      "400 lbs scooter",
      "heavy duty scooter"
    ],
    "target": "/products/anywell-x-024-wide-seat-electric-mobility-scooter",
    "preview": "Contact official support for guidance on this topic for your exact model."
  },
  {
    "id": "P16",
    "type": "product_options",
    "title": "20-mile range electric wheelchair",
    "phrases": [
      "20-mile range electric wheelchair",
      "20 mile wheelchair",
      "long range power wheelchair"
    ],
    "target": "/products/anywell-ys16-max-wide-seat-electric-wheelchair-20ah",
    "preview": "Compare the matching Anywell models for this search.",
    "options": [
      {
        "label": "YS16-1 MAX 20Ah",
        "href": "/products/anywell-ys16-max-wide-seat-electric-wheelchair-20ah"
      },
      {
        "label": "YA12-5",
        "href": "/products/anywell-ya12-5-long-range-durable-electric-wheelchair"
      }
    ]
  },
  {
    "id": "P17",
    "type": "product_options",
    "title": "15-mile range electric wheelchair",
    "phrases": [
      "15-mile range electric wheelchair",
      "15 mile wheelchair",
      "15-mile power chair"
    ],
    "target": "/products/ys16-1-max-heavy-duty-wide-seat-power-wheelchair-12ah",
    "preview": "Compare the matching Anywell models for this search.",
    "options": [
      {
        "label": "YS16-1 MAX 12Ah",
        "href": "/products/ys16-1-max-heavy-duty-wide-seat-power-wheelchair-12ah"
      },
      {
        "label": "YS12-15 PLUS",
        "href": "/products/anywell-ys12-15-plus-folding-electric-wheelchair"
      }
    ]
  },
  {
    "id": "P18",
    "type": "product_options",
    "title": "12Ah electric wheelchair",
    "phrases": [
      "12Ah electric wheelchair",
      "12 ah wheelchair",
      "12 amp hour power chair"
    ],
    "target": "/products/ys16-1-max-heavy-duty-wide-seat-power-wheelchair-12ah",
    "preview": "Compare the matching Anywell models for this search.",
    "options": [
      {
        "label": "YS16-1 MAX 12Ah",
        "href": "/products/ys16-1-max-heavy-duty-wide-seat-power-wheelchair-12ah"
      },
      {
        "label": "YS12-15 PLUS",
        "href": "/products/anywell-ys12-15-plus-folding-electric-wheelchair"
      }
    ]
  },
  {
    "id": "P19",
    "type": "product_options",
    "title": "20Ah electric wheelchair",
    "phrases": [
      "20Ah electric wheelchair",
      "20 ah wheelchair",
      "20 amp hour power chair"
    ],
    "target": "/products/anywell-ys16-max-wide-seat-electric-wheelchair-20ah",
    "preview": "Compare the matching Anywell models for this search.",
    "options": [
      {
        "label": "YS16-1 MAX 20Ah",
        "href": "/products/anywell-ys16-max-wide-seat-electric-wheelchair-20ah"
      },
      {
        "label": "YA12-5",
        "href": "/products/anywell-ya12-5-long-range-durable-electric-wheelchair"
      }
    ]
  },
  {
    "id": "P20",
    "type": "faq",
    "title": "Folding electric wheelchair",
    "phrases": [
      "folding electric wheelchair",
      "foldable power wheelchair",
      "folding power chair",
      "folding wheelchair for storage",
      "Is folding the same as easy lifting?",
      "foldable",
      "folding"
    ],
    "target": "/pages/faq#faq-group-buying",
    "preview": "Folding helps with storage. For car travel, also check folded dimensions, the heaviest piece you will lift, and whether a helper or ramp is needed. Compare a folding model only after those checks.",
    "item": "/pages/faq#faq-p20-folding-electric-wheelchair"
  },
  {
    "id": "P21",
    "type": "product",
    "title": "Aluminum electric wheelchair",
    "phrases": [
      "aluminum electric wheelchair",
      "aluminium power wheelchair",
      "aluminum alloy wheelchair"
    ],
    "target": "/products/anywell-ya12-5-long-range-durable-electric-wheelchair",
    "preview": "Contact official support for guidance on this topic for your exact model."
  },
  {
    "id": "P22",
    "type": "product",
    "title": "Removable battery mobility scooter",
    "phrases": [
      "removable battery mobility scooter",
      "scooter with removable battery",
      "X024 removable battery"
    ],
    "target": "/products/anywell-x-024-wide-seat-electric-mobility-scooter",
    "preview": "Contact official support for guidance on this topic for your exact model."
  },
  {
    "id": "P23",
    "type": "product",
    "title": "Wheelchair parts",
    "phrases": [
      "wheelchair parts",
      "replacement parts",
      "wheelchair accessories"
    ],
    "target": "/collections/parts",
    "preview": "Contact official support for guidance on this topic for your exact model."
  },
  {
    "id": "F01",
    "type": "faq",
    "title": "How do I charge my Anywell?",
    "phrases": [
      "How do I charge my Anywell?",
      "how to charge",
      "charging instructions",
      "charge battery",
      "charging help"
    ],
    "target": "/pages/faq#charging-help",
    "preview": "Contact official support for guidance on this topic for your exact model.",
    "group": "/pages/faq#faq-group-battery"
  },
  {
    "id": "F02",
    "type": "faq",
    "title": "How to charge YS16-1 MAX 12Ah",
    "phrases": [
      "How to charge YS16-1 MAX 12Ah",
      "YS16-1 MAX 12Ah charging",
      "YS16-1 MAX 12Ah charger instructions"
    ],
    "target": "/pages/faq#charging-ys16-1-max-heavy-duty-wide-seat-power-wheelchair-12ah",
    "preview": "Contact official support for guidance on this topic for your exact model.",
    "group": "/pages/faq#faq-group-battery"
  },
  {
    "id": "F03",
    "type": "faq",
    "title": "How to charge YS16-1 MAX 20Ah",
    "phrases": [
      "How to charge YS16-1 MAX 20Ah",
      "YS16-1 MAX 20Ah charging",
      "YS16-1 MAX 20Ah charger instructions"
    ],
    "target": "/pages/faq#charging-anywell-ys16-max-wide-seat-electric-wheelchair-20ah",
    "preview": "Contact official support for guidance on this topic for your exact model.",
    "group": "/pages/faq#faq-group-battery"
  },
  {
    "id": "F04",
    "type": "faq",
    "title": "How to charge YS12-15 PLUS",
    "phrases": [
      "How to charge YS12-15 PLUS",
      "YS12-15 PLUS charging",
      "YS12-15 PLUS charger instructions"
    ],
    "target": "/pages/faq#charging-anywell-ys12-15-plus-folding-electric-wheelchair",
    "preview": "Contact official support for guidance on this topic for your exact model.",
    "group": "/pages/faq#faq-group-battery"
  },
  {
    "id": "F05",
    "type": "faq",
    "title": "How to charge X-024",
    "phrases": [
      "How to charge X-024",
      "X-024 charging",
      "X-024 charger instructions"
    ],
    "target": "/pages/faq#charging-anywell-x-024-wide-seat-electric-mobility-scooter",
    "preview": "Contact official support for guidance on this topic for your exact model.",
    "group": "/pages/faq#faq-group-battery"
  },
  {
    "id": "F06",
    "type": "faq",
    "title": "How to charge YA12-5",
    "phrases": [
      "How to charge YA12-5",
      "YA12-5 charging",
      "YA12-5 charger instructions"
    ],
    "target": "/pages/faq#charging-anywell-ya12-5-long-range-durable-electric-wheelchair",
    "preview": "Contact official support for guidance on this topic for your exact model.",
    "group": "/pages/faq#faq-group-battery"
  },
  {
    "id": "F07",
    "type": "faq",
    "title": "Can I remove the battery to charge it?",
    "phrases": [
      "Can I remove the battery to charge it?",
      "remove battery for charging",
      "off-device charging"
    ],
    "target": "/pages/faq#charging-help",
    "preview": "Contact official support for guidance on this topic for your exact model.",
    "group": "/pages/faq#faq-group-battery"
  },
  {
    "id": "F08",
    "type": "faq",
    "title": "Battery is not charging",
    "phrases": [
      "Battery is not charging",
      "charger no light",
      "charging indicator",
      "battery charging problem"
    ],
    "target": "/pages/faq#charging-help",
    "preview": "Contact official support for guidance on this topic for your exact model.",
    "group": "/pages/faq#faq-group-battery"
  },
  {
    "id": "F09",
    "type": "faq",
    "title": "Which charger or battery do I need?",
    "phrases": [
      "Which charger or battery do I need?",
      "replacement battery",
      "replacement charger",
      "compatible charger"
    ],
    "target": "/pages/faq#faq-group-battery",
    "preview": "Confirm the exact model and battery version with Service & Parts before buying a charger or replacement battery. Capacity labels alone do not prove compatibility. Confirm current availability and the correct part with support; do not rely on a capacity label alone to choose a replacement.",
    "item": "/pages/faq#faq-f09-which-charger-or-battery-do-i-need"
  },
  {
    "id": "F10",
    "type": "faq",
    "title": "Where can Anywell deliver?",
    "phrases": [
      "Where can Anywell deliver?",
      "free shipping",
      "free ground shipping",
      "shipping cost",
      "shipping exclusions",
      "ship to Alaska",
      "ship to Hawaii",
      "Is shipping free to my ZIP code?",
      "shipping",
      "delivery area"
    ],
    "target": "/pages/faq#faq-group-shipping",
    "preview": "Eligible products ship by ground at no charge within the contiguous 48 U.S. states. Check your destination and product terms before ordering. Return freight follows a separate policy.",
    "item": "/pages/faq#faq-f10-where-can-anywell-deliver"
  },
  {
    "id": "F11",
    "type": "faq",
    "title": "When will my order arrive?",
    "phrases": [
      "When will my order arrive?",
      "delivery time",
      "shipping time",
      "estimated arrival",
      "delivery estimate by ZIP code",
      "How soon can I receive it?",
      "when will my order arrive"
    ],
    "target": "/pages/faq#faq-group-shipping",
    "preview": "Typical processing is 1–2 business days, followed by 3–7 business days in ground transit. These are estimates. Ask support to check the model and destination for your order.",
    "item": "/pages/faq#faq-f11-when-will-my-order-arrive"
  },
  {
    "id": "F12",
    "type": "faq",
    "title": "How can I return my order?",
    "phrases": [
      "How can I return my order?",
      "return policy",
      "refund request",
      "returns"
    ],
    "target": "/pages/faq#faq-group-returns",
    "preview": "You may request a return authorization within 60 days of delivery when policy conditions are met (including unused or indoor-check conditions and original packaging). Contact support for an RMA before sending anything back.",
    "item": "/pages/faq#faq-f12-how-can-i-return-my-order"
  },
  {
    "id": "F13",
    "type": "faq",
    "title": "What fees apply to a change-of-mind return?",
    "phrases": [
      "What fees apply to a change-of-mind return?",
      "return shipping fee",
      "restocking fee",
      "changed my mind"
    ],
    "target": "/pages/faq#faq-group-returns",
    "preview": "Change-of-mind returns usually require the buyer to cover return freight and a 20% restocking fee. Check the current return policy for exact terms.",
    "item": "/pages/faq#faq-f13-what-fees-apply-to-a-change-of-mind-return"
  },
  {
    "id": "F14",
    "type": "faq",
    "title": "The delivered item is damaged or incorrect",
    "phrases": [
      "The delivered item is damaged or incorrect",
      "damaged delivery",
      "defective product",
      "wrong item",
      "exchange"
    ],
    "target": "/pages/faq#faq-group-returns",
    "preview": "For eligible defects, shipping damage, or wrong items, return freight and restocking rules follow the return policy. Report damage or defects within 48 hours of delivery with photos or video through official support.",
    "item": "/pages/faq#faq-f14-the-delivered-item-is-damaged-or-incorrect"
  },
  {
    "id": "F15",
    "type": "faq",
    "title": "Can I cancel before shipment?",
    "phrases": [
      "Can I cancel before shipment?",
      "cancel order",
      "order cancellation"
    ],
    "target": "/pages/faq#faq-group-returns",
    "preview": "Orders cancelled before shipment are typically refunded in full under policy. After shipment, change-of-mind return rules and fees apply. Ask support to confirm your order stage first.",
    "item": "/pages/faq#faq-f15-can-i-cancel-before-shipment"
  },
  {
    "id": "F16",
    "type": "faq",
    "title": "What warranty support is available?",
    "phrases": [
      "What warranty support is available?",
      "warranty",
      "guarantee",
      "warranty start date",
      "warranty claim",
      "covered parts",
      "warranty exclusions",
      "How long is the warranty?"
    ],
    "target": "/pages/faq#faq-group-warranty",
    "preview": "Eligible vehicles have a 2-year limited warranty from delivery. Coverage is reviewed against the product, component and issue. Contact support for the current terms and claim steps.",
    "item": "/pages/faq#faq-f16-what-warranty-support-is-available"
  },
  {
    "id": "F17",
    "type": "faq",
    "title": "How do I get a compatible replacement part?",
    "phrases": [
      "How do I get a compatible replacement part?",
      "replacement parts",
      "spare parts",
      "compatible part",
      "joystick replacement",
      "tire",
      "inner tube",
      "front fork",
      "footrest",
      "brake",
      "Will this part fit my model?"
    ],
    "target": "/pages/faq#faq-group-warranty",
    "preview": "Replacement parts must match your exact model and version. Send the model and part details through official support before buying or installing a replacement.",
    "item": "/pages/faq#faq-f17-how-do-i-get-a-compatible-replacement-part"
  },
  {
    "id": "F18",
    "type": "faq",
    "title": "Where can I get the instructions?",
    "phrases": [
      "Where can I get the instructions?",
      "manual",
      "user guide",
      "setup instructions"
    ],
    "target": "/pages/faq#faq-group-warranty",
    "preview": "Request the user manual and setup guidance for your exact model and battery version through official support. Verified public PDF links for every model are not published here.",
    "item": "/pages/faq#faq-f18-where-can-i-get-the-instructions"
  },
  {
    "id": "F19",
    "type": "faq",
    "title": "How do I fold and load the wheelchair?",
    "phrases": [
      "How do I fold and load the wheelchair?",
      "folding steps",
      "fold without removing parts",
      "load into car",
      "car transport",
      "fit in trunk",
      "lifting weight",
      "heaviest lifting piece",
      "How do I fold it?"
    ],
    "target": "/pages/faq#faq-group-fit",
    "preview": "Check the exact folding procedure and lifting weight for your model. A folded chair can still be too heavy to lift alone. Plan a helper, ramp or lift where needed.",
    "item": "/pages/faq#faq-f19-how-do-i-fold-and-load-the-wheelchair"
  },
  {
    "id": "F20",
    "type": "faq",
    "title": "How do I load X-024 into a vehicle?",
    "phrases": [
      "How do I load X-024 into a vehicle?",
      "X024 transport",
      "remove seat and battery",
      "scooter loading"
    ],
    "target": "/pages/faq#faq-group-fit",
    "preview": "For X-024, the seat and battery can be removed before loading. The base is about 61 lb after removal and is not the full assembled weight. Plan a helper, ramp, or lift based on your ability.",
    "item": "/pages/faq#faq-f20-how-do-i-load-x-024-into-a-vehicle"
  },
  {
    "id": "F21",
    "type": "faq",
    "title": "How do I check seat room?",
    "phrases": [
      "How do I check seat room?",
      "seat size",
      "seat width",
      "wide seat fit",
      "armrest clearance",
      "hip room",
      "will I fit",
      "Is the seat comfortable for me?"
    ],
    "target": "/pages/faq#faq-group-fit",
    "preview": "Start with usable seat width and armrest clearance, then check seat depth and foot support. A rated weight capacity does not by itself confirm a comfortable fit.",
    "item": "/pages/faq#faq-f21-how-do-i-check-seat-room"
  },
  {
    "id": "F22",
    "type": "faq",
    "title": "Will the chair clear my doorway?",
    "phrases": [
      "Will the chair clear my doorway?",
      "door width",
      "doorway clearance",
      "overall width"
    ],
    "target": "/pages/faq#faq-group-fit",
    "preview": "YS16-1 MAX overall width is up to 28.35 in; that is not the 22.05 in inner seat width. Measure the clear doorway opening and leave room to maneuver. Confirm dimensions for other models separately.",
    "item": "/pages/faq#faq-f22-will-the-chair-clear-my-doorway"
  },
  {
    "id": "F23",
    "type": "faq",
    "title": "How far can each battery version travel?",
    "phrases": [
      "How far can each battery version travel?",
      "battery range",
      "range per charge",
      "miles per charge",
      "real-world range",
      "12Ah vs 20Ah",
      "Will the battery cover my daily route?"
    ],
    "target": "/pages/faq#faq-group-battery",
    "preview": "Choose the battery version for your daily route and charging plan. Published range is up to the stated distance; rider load, surface, temperature and battery condition affect actual mileage.",
    "item": "/pages/faq#faq-f23-how-far-can-each-battery-version-travel"
  },
  {
    "id": "F24",
    "type": "faq",
    "title": "How can I reach customer support?",
    "phrases": [
      "How can I reach customer support?",
      "contact support",
      "customer service",
      "order help",
      "repair help"
    ],
    "target": "/pages/faq#faq-group-warranty",
    "preview": "Use the official phone, email, or contact form for model selection, orders, parts, warranty, and after-sales questions.",
    "item": "/pages/faq#faq-f24-how-can-i-reach-customer-support"
  },
  {
    "id": "F25",
    "type": "faq",
    "title": "Can I take the battery on an airplane?",
    "phrases": [
      "Can I take the battery on an airplane?",
      "airline battery rules",
      "airline approved wheelchair",
      "fly with wheelchair",
      "air travel",
      "battery airline approval",
      "Can I bring it on a plane?"
    ],
    "target": "/pages/faq#faq-group-battery",
    "preview": "Before booking, check the exact battery specification and your airline’s current rules. Folding or portability does not automatically mean the battery is accepted for air travel.",
    "item": "/pages/faq#faq-f25-can-i-take-the-battery-on-an-airplane"
  },
  {
    "id": "U01",
    "type": "disambiguate",
    "title": "Battery",
    "phrases": [
      "battery",
      "batteries",
      "batery（拼写建议）",
      "wheelchair battery",
      "power chair battery"
    ],
    "target": "/pages/faq#faq-group-ambiguous",
    "item": "/pages/faq#faq-u01-battery",
    "preview": "“Battery” can mean charging help, range by battery version, replacement purchasing, or warranty coverage. Choose the topic that matches your question, then confirm your exact model.",
    "options": [
      {
        "label": "Charging help",
        "href": "/pages/faq#charging-help"
      },
      {
        "label": "Battery range by version",
        "href": "/pages/faq#faq-group-battery"
      },
      {
        "label": "Replacement battery",
        "href": "/pages/faq#faq-group-battery"
      },
      {
        "label": "Battery warranty",
        "href": "/pages/faq#faq-group-warranty"
      }
    ]
  },
  {
    "id": "U02",
    "type": "disambiguate",
    "title": "Charge",
    "phrases": [
      "charge",
      "charging",
      "charges",
      "how much is the charge?"
    ],
    "target": "/pages/faq#faq-group-ambiguous",
    "item": "/pages/faq#faq-u02-charge",
    "preview": "“Charge” can mean charging the battery, shipping charges, or return fees. Choose the topic that matches your question, then open that answer or contact support.",
    "options": [
      {
        "label": "Charging the battery",
        "href": "/pages/faq#charging-help"
      },
      {
        "label": "Shipping charges",
        "href": "/pages/faq#faq-group-shipping"
      },
      {
        "label": "Return fees",
        "href": "/pages/faq#faq-group-returns"
      }
    ]
  },
  {
    "id": "U03",
    "type": "disambiguate",
    "title": "16-1",
    "phrases": [
      "16-1",
      "YS16-1",
      "16 1",
      "16-1 PLUS",
      "YS16-1 MAX"
    ],
    "target": "/pages/faq#faq-group-ambiguous",
    "item": "/pages/faq#faq-u03-16-1",
    "preview": "“16-1” may mean an older 16-1 / PLUS name or the current YS16-1 MAX. Intent is unclear, so we do not redirect silently. Confirm your exact model, or compare the current MAX options below.",
    "options": [
      {
        "label": "Current YS16-1 MAX 12Ah",
        "href": "/products/ys16-1-max-heavy-duty-wide-seat-power-wheelchair-12ah"
      },
      {
        "label": "Current YS16-1 MAX 20Ah",
        "href": "/products/anywell-ys16-max-wide-seat-electric-wheelchair-20ah"
      },
      {
        "label": "Contact support to confirm model",
        "href": "/pages/contact"
      }
    ]
  },
  {
    "id": "N01",
    "type": "faq",
    "title": "Lightweight power wheelchair",
    "phrases": [
      "lightweight power wheelchair",
      "lightweight electric wheelchair",
      "light weight power chair",
      "weight with battery",
      "weight without battery",
      "How much will I actually lift?",
      "lightweight"
    ],
    "target": "/pages/faq#faq-group-buying",
    "preview": "If low lifting weight matters, compare the actual weight you will lift, including which parts are removed. Also check seat fit, rated capacity and your daily route before choosing.",
    "item": "/pages/faq#faq-n01-lightweight-power-wheelchair"
  },
  {
    "id": "N02",
    "type": "faq",
    "title": "Ultralight electric wheelchair",
    "phrases": [
      "ultralight electric wheelchair",
      "ultra lightweight power chair",
      "featherweight electric wheelchair",
      "wheelchair under 40 lb",
      "wheelchair under 50 lb",
      "carbon fiber power wheelchair"
    ],
    "target": "/pages/faq#faq-group-buying",
    "preview": "If a strict lifting limit is essential, confirm the exact configuration and measured lifting weight with us first. We will tell you when a model does not meet that requirement.",
    "item": "/pages/faq#faq-n02-ultralight-electric-wheelchair"
  },
  {
    "id": "N03",
    "type": "faq",
    "title": "Can I lift it by myself?",
    "phrases": [
      "Can I lift it by myself?",
      "lift by myself",
      "one person lifting",
      "easy to lift into car",
      "caregiver-assisted loading",
      "heaviest lifting piece"
    ],
    "target": "/pages/faq#faq-group-buying",
    "preview": "For frequent car trips, plan how each piece will be loaded. If independent lifting is a must, confirm the lifting weight and loading method before ordering. A helper, ramp or lift may be needed.",
    "item": "/pages/faq#faq-n03-can-i-lift-it-by-myself"
  },
  {
    "id": "N04",
    "type": "faq",
    "title": "Folded dimensions",
    "phrases": [
      "folded dimensions",
      "fold for storage",
      "compact storage",
      "foldable wheelchair dimensions",
      "fits in closet",
      "How much storage space does it need?"
    ],
    "target": "/pages/faq#faq-group-buying",
    "preview": "If home storage is your priority, compare the folded dimensions with your available space. Check the exact model and folding steps; storage fit and lifting ease are separate questions.",
    "item": "/pages/faq#faq-n04-folded-dimensions"
  },
  {
    "id": "N05",
    "type": "faq",
    "title": "Will it fit in my car trunk?",
    "phrases": [
      "Will it fit in my car trunk?",
      "fits in trunk",
      "car boot wheelchair",
      "SUV loading",
      "trunk opening",
      "folded wheelchair in car"
    ],
    "target": "/pages/faq#faq-group-buying",
    "preview": "Measure the trunk opening and usable space, then compare the exact folded or disassembled dimensions. Plan lifting and secure transport as well as whether the product fits.",
    "item": "/pages/faq#faq-n05-will-it-fit-in-my-car-trunk"
  },
  {
    "id": "N06",
    "type": "faq",
    "title": "Portable electric wheelchair",
    "phrases": [
      "portable electric wheelchair",
      "travel power wheelchair",
      "portable mobility chair",
      "travel by car",
      "daily errands",
      "moving and carrying",
      "portable wheelchair for travel"
    ],
    "target": "/pages/faq#faq-group-buying",
    "preview": "Tell us how you plan to travel: daily outings, car transport or flying. Each needs different checks. We can help compare the route, loading plan and battery details for that use.",
    "item": "/pages/faq#faq-n06-portable-electric-wheelchair"
  },
  {
    "id": "N07",
    "type": "faq",
    "title": "Medicare coverage",
    "phrases": [
      "Medicare coverage",
      "Medicare wheelchair",
      "does Medicare cover power wheelchairs",
      "Medicare-approved supplier",
      "insurance billing through Medicare",
      "medicare"
    ],
    "target": "/pages/faq#faq-group-buying",
    "preview": "Medicare coverage depends on its requirements and an enrolled supplier. Before buying for coverage, ask whether Anywell can handle the billing or documentation required for your specific request.",
    "item": "/pages/faq#faq-n07-medicare-coverage"
  },
  {
    "id": "N08",
    "type": "faq",
    "title": "Medicaid wheelchair coverage",
    "phrases": [
      "Medicaid wheelchair coverage",
      "Medicaid power wheelchair",
      "state insurance wheelchair",
      "Medicaid supplier",
      "does Medicaid pay for a wheelchair"
    ],
    "target": "/pages/faq#faq-group-buying",
    "preview": "Check with your own Medicaid plan about eligibility, supplier and approval requirements before purchasing. Ask whether Anywell can take part in that specific process before placing an order.",
    "item": "/pages/faq#faq-n08-medicaid-wheelchair-coverage"
  },
  {
    "id": "N09",
    "type": "faq",
    "title": "Insurance reimbursement",
    "phrases": [
      "insurance reimbursement",
      "insurance covered wheelchair",
      "private insurance",
      "reimbursement paperwork",
      "prescription paperwork",
      "insurance billing",
      "Can I claim this purchase?"
    ],
    "target": "/pages/faq#faq-group-buying",
    "preview": "Ask your insurer about the exact product, approval process and required documents before ordering. Confirm with Anywell what paperwork or billing support is available. Reimbursement is not guaranteed.",
    "item": "/pages/faq#faq-n09-insurance-reimbursement"
  },
  {
    "id": "B01",
    "type": "faq",
    "title": "Battery type and voltage",
    "phrases": [
      "battery type and voltage",
      "lithium battery",
      "lead acid battery",
      "battery voltage",
      "12Ah battery",
      "20Ah battery",
      "Which battery does this model use?"
    ],
    "target": "/pages/faq#faq-group-battery",
    "preview": "Match the battery to the exact model and version. Capacity alone does not establish chemistry, voltage or charger compatibility. Check your device label or ask support to confirm the details.",
    "item": "/pages/faq#faq-b01-battery-type-and-voltage"
  },
  {
    "id": "B02",
    "type": "faq",
    "title": "How long does charging take?",
    "phrases": [
      "How long does charging take?",
      "battery charging time",
      "hours to charge",
      "fully charged time",
      "charging indicator"
    ],
    "target": "/pages/faq#faq-b02-how-long-does-charging-take",
    "preview": "Charging time and indicators depend on the battery and matching charger. Ask support for the instructions for your exact configuration rather than using a generic time or light-color rule.",
    "item": "/pages/faq#faq-b02-how-long-does-charging-take",
    "group": "/pages/faq#faq-group-battery"
  },
  {
    "id": "B03",
    "type": "faq",
    "title": "Battery lifespan",
    "phrases": [
      "battery lifespan",
      "battery life expectancy",
      "how many years does battery last",
      "battery loses range",
      "battery replacement interval"
    ],
    "target": "/pages/faq#faq-group-battery",
    "preview": "Battery lifespan is different from range per charge. If range has changed, contact support with your model and battery details for review. We cannot promise one replacement interval for every configuration.",
    "item": "/pages/faq#faq-b03-battery-lifespan"
  },
  {
    "id": "B04",
    "type": "faq",
    "title": "Replacement battery cost",
    "phrases": [
      "replacement battery cost",
      "buy wheelchair battery",
      "replacement battery price",
      "battery in stock",
      "compatible battery for Anywell",
      "where to get a new battery",
      "replacement battery"
    ],
    "target": "/pages/faq#faq-group-battery",
    "preview": "Contact support to confirm the compatible replacement, current availability and quote for your model. A matching capacity label alone does not make a battery compatible.",
    "item": "/pages/faq#faq-b04-replacement-battery-cost"
  },
  {
    "id": "B05",
    "type": "faq",
    "title": "Battery storage and care",
    "phrases": [
      "battery storage and care",
      "battery storage",
      "winter battery care",
      "battery maintenance",
      "charging safety",
      "unused battery care"
    ],
    "target": "/pages/faq#faq-group-battery",
    "preview": "Use the original matching charger and keep the battery and connections dry. For storage temperature and longer-term care, request the instructions for your exact battery configuration.",
    "item": "/pages/faq#faq-b05-battery-storage-and-care"
  },
  {
    "id": "D01",
    "type": "faq",
    "title": "When will my order ship?",
    "phrases": [
      "When will my order ship?",
      "ready to ship",
      "processing time",
      "dispatch date",
      "ship-from location",
      "warehouse location",
      "in stock",
      "ship immediately"
    ],
    "target": "/pages/faq#faq-group-shipping",
    "preview": "Published policy lists a California warehouse and typical processing of 1–2 business days. Contact support to confirm availability and actual dispatch details for your model or order.",
    "item": "/pages/faq#faq-d01-when-will-my-order-ship"
  },
  {
    "id": "D02",
    "type": "faq",
    "title": "Where is my order tracking?",
    "phrases": [
      "Where is my order tracking?",
      "track my order",
      "tracking number",
      "tracking email",
      "order status",
      "shipment tracking"
    ],
    "target": "/pages/faq#faq-group-shipping",
    "preview": "After dispatch, the published policy provides for a shipment email with tracking details. Use that email’s tracking link, or contact official support if it is missing or unclear.",
    "item": "/pages/faq#faq-d02-where-is-my-order-tracking"
  },
  {
    "id": "D03",
    "type": "faq",
    "title": "My delivery is delayed",
    "phrases": [
      "My delivery is delayed",
      "tracking not updating",
      "late delivery",
      "delayed shipment",
      "package not delivered",
      "missed delivery estimate"
    ],
    "target": "/pages/faq#faq-group-shipping",
    "preview": "If tracking has stalled or delivery is later than estimated, contact support for an order-specific check. We need the carrier and shipment status before advising the next step.",
    "item": "/pages/faq#faq-d03-my-delivery-is-delayed"
  },
  {
    "id": "D04",
    "type": "faq",
    "title": "Delivery and setup assistance",
    "phrases": [
      "delivery and setup assistance",
      "curbside delivery",
      "inside delivery",
      "white glove delivery",
      "assembly on delivery",
      "setup help",
      "signature required"
    ],
    "target": "/pages/faq#faq-group-shipping",
    "preview": "Plan how the product will be received and moved into place. Ask support to confirm the delivery service and setup instructions; free ground shipping does not establish in-home setup availability.",
    "item": "/pages/faq#faq-d04-delivery-and-setup-assistance"
  },
  {
    "id": "C01",
    "type": "faq",
    "title": "Comfortable power wheelchair",
    "phrases": [
      "comfortable power wheelchair",
      "comfortable electric wheelchair",
      "comfy wheelchair",
      "comfort",
      "soft seat",
      "comfortable for long sitting",
      "Will it be comfortable for me?",
      "comfortable"
    ],
    "target": "/pages/faq#faq-group-fit",
    "preview": "Comfort starts with fit: seat room, depth, cushion, back support and full foot support. Compare those with your needs. A wider seat or thicker cushion alone cannot guarantee comfort for longer sitting.",
    "item": "/pages/faq#faq-c01-comfortable-power-wheelchair"
  },
  {
    "id": "C02",
    "type": "faq",
    "title": "Seat depth and back support",
    "phrases": [
      "seat depth and back support",
      "seat depth",
      "backrest support",
      "back cushion",
      "posture support",
      "thigh support",
      "knee clearance"
    ],
    "target": "/pages/faq#faq-group-fit",
    "preview": "Compare seat depth and back support as well as width. Check that your thighs and feet are supported without pressure behind the knees. Confirm the exact dimensions and any adjustment range before ordering.",
    "item": "/pages/faq#faq-c02-seat-depth-and-back-support"
  },
  {
    "id": "C03",
    "type": "faq",
    "title": "Footrest fit",
    "phrases": [
      "footrest fit",
      "footrest height",
      "short legs wheelchair",
      "seat to footrest distance",
      "foot support adjustment",
      "leg length fit"
    ],
    "target": "/pages/anywell-fit-check#leg-length-fit",
    "preview": "Use your seated lower-leg measurement to check foot support, rather than standing height alone. Confirm the model’s seat-to-foot-support distance and adjustment range, and plan transfers for your needs.",
    "item": "/pages/faq#faq-c03-footrest-fit",
    "group": "/pages/faq#faq-group-fit"
  },
  {
    "id": "C04",
    "type": "faq",
    "title": "Seat and armrest adjustment",
    "phrases": [
      "seat and armrest adjustment",
      "adjustable seat",
      "armrest height",
      "removable armrests",
      "reclining backrest",
      "seat cushion replacement"
    ],
    "target": "/pages/faq#faq-group-fit",
    "preview": "Ask which adjustments and compatible cushions are supported by the exact model. Check how any change affects seat height, foot support and transfers before using it.",
    "item": "/pages/faq#faq-c04-seat-and-armrest-adjustment"
  },
  {
    "id": "C05",
    "type": "faq",
    "title": "Joystick and controls reach",
    "phrases": [
      "joystick and controls reach",
      "easy to use controls",
      "joystick reach",
      "left hand joystick",
      "right hand controller",
      "controller position"
    ],
    "target": "/pages/faq#faq-group-fit",
    "preview": "Confirm the controller position and reach for the exact model. Your hand support and ability to operate the controls matter. Do not use the joystick as a support handle during transfers.",
    "item": "/pages/faq#faq-c05-joystick-and-controls-reach"
  },
  {
    "id": "S01",
    "type": "faq",
    "title": "Are there extra shipping fees?",
    "phrases": [
      "Are there extra shipping fees?",
      "hidden shipping fees",
      "expedited shipping",
      "overnight shipping",
      "free return shipping",
      "shipping surcharge"
    ],
    "target": "/pages/faq#faq-group-shipping",
    "preview": "Current policy offers ground shipping, with no expedited option. Check your destination and product terms before ordering. Return freight and fees follow the separate return policy.",
    "item": "/pages/faq#faq-s01-are-there-extra-shipping-fees"
  },
  {
    "id": "W01",
    "type": "faq",
    "title": "Battery warranty coverage",
    "phrases": [
      "battery warranty coverage",
      "is battery covered",
      "battery warranty",
      "battery warranty extension",
      "charger warranty",
      "battery replacement under warranty"
    ],
    "target": "/pages/faq#faq-group-warranty",
    "preview": "Battery coverage and extension options must be checked separately. The body-and-chassis extension excludes the battery. Ask support to confirm the current coverage for your battery, charger and issue.",
    "item": "/pages/faq#faq-w01-battery-warranty-coverage"
  },
  {
    "id": "W02",
    "type": "faq",
    "title": "Warranty costs and exclusions",
    "phrases": [
      "warranty costs and exclusions",
      "warranty labor cost",
      "warranty freight",
      "wear and tear",
      "tire warranty",
      "warranty exclusions",
      "Is every repair free?"
    ],
    "target": "/pages/faq#faq-group-warranty",
    "preview": "A limited warranty does not mean every repair and related cost is covered. Ask support to review the component and issue and confirm any labor, freight or other charge before work begins.",
    "item": "/pages/faq#faq-w02-warranty-costs-and-exclusions"
  },
  {
    "id": "W03",
    "type": "faq",
    "title": "Extended warranty",
    "phrases": [
      "extended warranty",
      "warranty extension",
      "extend coverage",
      "extended body warranty",
      "warranty claim documents",
      "purchase proof"
    ],
    "target": "/pages/faq#faq-group-warranty",
    "preview": "Review extension options by component: body-and-chassis coverage and battery coverage are separate. For a claim, contact support with purchase and product details for an eligibility review.",
    "item": "/pages/faq#faq-w03-extended-warranty"
  },
  {
    "id": "R01",
    "type": "faq",
    "title": "Wheelchair repair near me",
    "phrases": [
      "wheelchair repair near me",
      "local wheelchair repair",
      "authorized repair center",
      "in-home repair",
      "on-site service",
      "repair technician near me",
      "repair"
    ],
    "target": "/pages/faq#faq-group-warranty",
    "preview": "Contact support with your location and model to ask which repair options are actually available. A support channel does not by itself guarantee local or in-home repair service.",
    "item": "/pages/faq#faq-r01-wheelchair-repair-near-me"
  },
  {
    "id": "R02",
    "type": "faq",
    "title": "Repair cost and turnaround",
    "phrases": [
      "repair cost and turnaround",
      "out of warranty repair",
      "repair price",
      "how much is repair",
      "repair turnaround time",
      "parts lead time"
    ],
    "target": "/pages/faq#faq-group-warranty",
    "preview": "Repair cost and timing depend on the issue, compatible parts and available service. Ask for the proposed repair path, estimate and any charges before agreeing to the work.",
    "item": "/pages/faq#faq-r02-repair-cost-and-turnaround"
  },
  {
    "id": "R03",
    "type": "faq",
    "title": "Wheelchair troubleshooting",
    "phrases": [
      "wheelchair troubleshooting",
      "wheelchair not moving",
      "will not turn on",
      "joystick not working",
      "error code",
      "motor problem",
      "brake problem"
    ],
    "target": "/pages/faq#faq-group-warranty",
    "preview": "For a fault affecting safe operation, stop using the product and contact official support. Share the model and symptoms through that channel. Do not bypass brakes or safety devices to test a fault.",
    "item": "/pages/faq#faq-r03-wheelchair-troubleshooting"
  },
  {
    "id": "R04",
    "type": "faq",
    "title": "Setup and user manual",
    "phrases": [
      "setup and user manual",
      "assembly instructions",
      "initial setup",
      "user manual PDF",
      "how to use power wheelchair",
      "setup support"
    ],
    "target": "/pages/faq#faq-group-warranty",
    "preview": "Request the setup and user instructions for your exact model and version. Contact support when a step or connection is unclear rather than improvising assembly or using another model’s instructions.",
    "item": "/pages/faq#faq-r04-setup-and-user-manual"
  },
  {
    "id": "A01",
    "type": "faq",
    "title": "How do I choose a safe and comfortable wheelchair?",
    "phrases": [
      "How do I choose a safe and comfortable wheelchair?",
      "safe power wheelchair",
      "stable wheelchair",
      "comfort and safety",
      "choosing a wheelchair",
      "wheelchair buying checklist",
      "how to choose",
      "comfortable wheelchair"
    ],
    "target": "/pages/faq#faq-group-buying",
    "preview": "Compare fit, rated capacity, foot support, controls, your daily route, transfers and transport needs. Weight or seat width alone does not establish safety or comfort. Confirm whether the model suits your own use.",
    "item": "/pages/faq#faq-a01-how-do-i-choose-a-safe-and-comfortable-wheelchair"
  }
];
